module.exports = __webpack_public_path__ + "static/50-future-of-work-are-companies-failing-at-people-management-2d47b9cffdcb8255b73f25a1de79a8df.png";